import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import IdTypesList from "./List";
import IdTypeForm from "./Form";
import IdType from "./View";
import NotFound from "../NotFound";

import { PageHeader } from "../Shared";

import { idTypeActions } from "./actions/idtypes.actions";

export class ManageIdTypes extends Component {
  componentDidMount() {
    this.getIdTypes();
  }

  getIdTypes = () => {
    this.props.getIdTypes();
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;

    return (
      <div className="IdTypes">
        <Row>
          <Col>
            <PageHeader pageId="idtypes" pageTitle="Manage Identification Types" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <IdTypesList
                  match={match}
                  data={response}
                  loadData={this.getIdTypes}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route
              path={`${match.url}/list`}
              render={() => (
                <IdTypesList
                  match={match}
                  data={response}
                  loadData={this.getIdTypes}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route path={`${match.url}/add`} component={IdTypeForm} />
            <Route path={`${match.url}/view/:id`} component={IdType} />
            <Route path={`${match.url}/edit/:id`} component={IdTypeForm} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.idTypes;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getIdTypes: bindActionCreators(
      idTypeActions.getAllIdTypes,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageIdTypes);
